module.exports = __webpack_public_path__ + "application/templates/default/inner/publications/inner/keywords/keywords.template.html";